<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" :id="offcanvas_id" data-bs-backdrop="static" :aria-labelledby="`${offcanvas_id}_label`">
    <div class="offcanvas-header">
      <button class="btn-back" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" aria-label="Close">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>
      <h5 class="offcanvas-title d-block" :id="`${offcanvas_id}_label`">{{ $t('dashboard.notification') }}</h5>
    </div>
    <div class="offcanvas-body scrollbar">
      <ul v-if="notification && notification.length > 0">
        <li :id="`event_${item.uuid}`" v-for="(item, index) in notification" :key="index" :data-test="`btnNotificationClicked_${index}`">
          <h5>
            <span></span>
            {{ $filters.dateTime(item.date) }}
          </h5>

          <h3>{{ item.csvUpload ? $t('clinicConfig.uploadCsvCompleted') : $t('clinicConfig.newExam') }}</h3>

          <p>
            {{ item.csvUpload ? $t('clinicConfig.importCountMessage', {insertedCount: item.insertedCount}) : $t('clinicConfig.newExamMessage') }}
            {{ item.csvUpload && item.skippedCount > 0 ? $t('clinicConfig.duplicated', { count: item.skippedCount }) : '' }}
          </p>

          <button 
            v-if="item.csvUpload && item.skippedCount > 0"
            class="btn btn-outline-secondary" id="btnDuplicatedPatients" type="button" name="button"
            :data-title="$t('tooltips.download')" data-test="`btnDuplicatedPatients`"
            @click="downloadSkippedCsv(item)">
            <IconDownload />
            <span>{{ $t('clinicConfig.downloadSkipped') }}</span>
          </button>

          <button class="btn btn-outline-secondary" type="button" name="button" v-if="!item.csvUpload" @click="notificationClicked(item.exam.id)">{{ $t('clinicConfig.accessNow' )}}</button>
        </li>
      </ul>

      <div class="no-msg" v-else>
        <h3>{{ $t('dashboard.noNotification') }}</h3>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.offcanvas {
  .offcanvas-title {
    color:                              var(--Brand-Primary, #1B294A);
    font-size:                          38px;
    font-weight:                        300;
    line-height:                        normal;
    margin:                             26px 0;
  }

  .offcanvas-body {
    overflow-y:                         auto;
    padding-right:                      20px;

    h5 {
      font-size:                        var(--font-size-12);
      font-weight:                      400;
      display:                          flex;
      align-items:                      center;
      gap:                              5px;

      span {
        @include                        border_radius(50%);
        display:                        inline-block;
        width:                          11px;
        height:                         11px;
        background:                     var(--Shades-30);
      }
    }

    h3 {
      font-size:                        18px;
      font-weight:                      500;
    }

    h5,
    h3,
    p,
    .btn-outline-secondary {
      color:                            var(--Brand-Primary);
      line-height:                      140%; /* 19.6px */
    }

    p {
      font-size:                        var(--font-size-14);
      font-weight:                      300;
      margin-bottom:                    1rem;
    }

    ul {
      list-style-type:                  none;
      display:                          flex;
      flex-direction:                   column;
      align-items:                      flex-start;
      gap:                              19px;
      padding:                          0;

      li {
        width:                          100%;
        padding-top:                    10px;
        border-top:                     1px solid var(--Shades-20, #F0F0F0);



        .btn-outline-secondary {
          font-size:                    11px;
          font-weight:                  700;
          line-height:                  normal;
          letter-spacing:               3.3px;
          text-transform:               uppercase;
          width:                        100%;
        }
      }
    }

    .no-msg {
      height:                           100%;
      display:                          flex;
      align-items:                      center;
      justify-content:                  center;
      overflow:                         hidden;
    }

    #btnDuplicatedPatients {
      gap:                              0.5rem;
      padding:                          0;
      height:                           35px;
    }
  }
}
</style>

<script>
export default {
  name: 'NotificationsOffcanvas',
  props: {
    offcanvas_id: String,
    notification: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    offcanvas_notification: null,
    // notification: null,
  }),
  mounted() {
    console.log('this.notification', this.notification);
  },
  methods: {
    show(options = {}) {
      // if (options.notification)
      //   this.notification = options.notification

      this.offcanvas_notification = new bootstrap.Offcanvas(document.getElementById(this.offcanvas_id)).show();

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    doConfirm() {
      this.offcanvas_notification = null;
      this.resolvePromise(true)
    },

    doCancel() {
      this.offcanvas_notification = null;
      this.resolvePromise(false)
    },

    async addFake() {
      try {
        let response = await this.$notificationService.addFakeNotifications();
      } catch (e) {
        console.log('erro', e);
      }
    },
    notificationClicked(examid) {
      examid ? this.$router.push({name: 'exam-show', params: {examID: examid}, query: {tab: 'images'}})
               : this.$router.push({name: 'patient-list'})
    },

    downloadSkippedCsv(notificationItem) {
      const skippedData = notificationItem.skippedDetails;
      if (!skippedData || skippedData.length === 0) 
        return;

      const headers = [
        this.$t('clinicConfig.columns.row'),
        this.$t('clinicConfig.columns.name'),
        this.$t('clinicConfig.columns.document'),
        this.$t('clinicConfig.columns.reason')
      ];
      
      const rows = skippedData.map(item => [
        item.row,
        `"${item.name}"`,
        `"${item.document === 'N/A' ? 'N/A' : this.$t(item.document)}"`,
        this.$t(`clinicConfig.${item.reason}`)
      ]);

      const csvContent = [
        headers.join(","),
        ...rows.map(e => e.join(","))
      ].join("\n");

      const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' });
      const filenameBase = this.$t('clinicConfig.filenameDuplicated');
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      const dateFormat = this.$i18n.t('dateFormat')
      
      const dateStr = moment(notificationItem.date).format(dateFormat);
      link.setAttribute("href", url);
      link.setAttribute("download", `${filenameBase}_${dateStr}.csv`);
      link.style.visibility = 'hidden';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  }
}
</script>
